import About from './About';
import ProjectCard from './ProjectCard';

const Home = () => {
  return (
    <div className="home">
      <About />

      <ProjectCard />
    </div>
  );
};
export default Home;
